module.exports = __webpack_public_path__ + "static/media/PushtimargImage9.97994d98.jpg";